export var FindingExclusionSortField;
(function (FindingExclusionSortField) {
    FindingExclusionSortField["FINDING_EXCLUSION_SORT_FIELD_PATH"] = "PATH";
    FindingExclusionSortField["FINDING_EXCLUSION_SORT_FIELD_DETECTOR"] = "DETECTOR";
    FindingExclusionSortField["FINDING_EXCLUSION_SORT_FIELD_SCOPE"] = "SCOPE";
    FindingExclusionSortField["FINDING_EXCLUSION_SORT_FIELD_RESOURCE_NAME"] = "RESOURCE_NAME";
    FindingExclusionSortField["FINDING_EXCLUSION_SORT_FIELD_UPDATED_AT"] = "UPDATED_AT";
})(FindingExclusionSortField || (FindingExclusionSortField = {}));
